import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class LoyaltyProgramService {

    static getLoyaltyProgramByPharmacyId(pharmacyId) {
        return axios.get(`${URL.PMS_LOYALTY_PROGRAM_BY_PHARMACY_ID}/${pharmacyId}`, LoyaltyProgramService.getAuthHeader());
    }

    static createUpdateLoyaltyProgram(pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_UPDATE_LOYALTY_PROGRAM}/${pharmacyId}`, data, LoyaltyProgramService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return { headers: { Authorization: `Bearer ${accessToken}` } };
    }

}
